module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av205-c3d1e3e9bc245ecd2607ffe41445c75b.jpg";